import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Apollo } from 'apollo-angular';
import { Container } from '../../containers/container';
import { Template } from '../../entities/template/template';
import { TemplateVariant } from '../../entities/template-variant/template-variant';
import { LoadingService } from '../../services/loading.service';
import { TemplateVariantsService } from '../../services/template-variants/template-variants.service';
import { ConfirmDialogEventType, ConfirmDialogSeverity } from '../confirmDialog/confirmDialogComponent';
import { ConfirmDialogService } from '../confirmDialog/confirmDialogService';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent extends Container<fromGraphQl.TemplatesQueryResponse>
implements OnInit
{
public templates: Template[] = [];
@Input() withMainHeadline = true;


constructor(
  loadingService: LoadingService,
  apollo: Apollo,
  private confirmDialogService: ConfirmDialogService,
  private router: Router,
  private templateVaraintService: TemplateVariantsService,
  @Inject('env') environment : any
) {
  super(apollo, loadingService, fromGraphQl.TEMPLATES_QUERY, environment);
}

ngOnInit(): void {
  this.subscribeToQuery({
    isCustomizable: true
  });
  }

handleSubscriptionResult(data: fromGraphQl.TemplatesQueryResponse): void {
  this.loadingService.setLoading(false);
  if (data) {
    // console.log('dta', data);
    this.queryRef.stopPolling();
    this.templates = Template.createTemplates(data.templates);
  }
}

createTemplateVariant(templateKey: string) {
  this.router.navigate(['./settings/templates/'+templateKey+'/create/']);
}

confirmDialog(variant: TemplateVariant): void {
  const message = 'Möchtest Du die Vorlage (' + variant.name +') wirklich löschen?';
  const dialogRef = this.confirmDialogService.open({
    message: message,
    header: 'Vorlage löschen',
    severity: ConfirmDialogSeverity.WARN,
    confirmLabel: 'Löschen'
  });

  dialogRef.onClose.subscribe((result: ConfirmDialogEventType) => {
    if (result === ConfirmDialogEventType.CONFIRM) {
      this.loadingService.setLoading(true);
      this.deleteVariant(variant.id);
    }
  });
}

deleteVariant(id: string) {
  this.templateVaraintService.deleteTemplateVariant(
    id,
    this.returnCallback(this.router)
  );
}

returnCallback(router: Router): void {
  setTimeout(() => {
    this.loadingService.setLoading(false);
    this.queryRef.refetch();
  }, 500);
}
viewTemplateVariant(templateKey: string, id: string) {
  // console.log('id', id)
  if (id) {
    this.router.navigate(['./settings/templates/' +templateKey + '/' + id]);
  }
}
}
